import { render, staticRenderFns } from "./dashboard.badge.component.vue?vue&type=template&id=13d9d36e"
import script from "./dashboard.badge.component.vue?vue&type=script&lang=js"
export * from "./dashboard.badge.component.vue?vue&type=script&lang=js"
import style0 from "./dashboard.badge.component.vue?vue&type=style&index=0&id=13d9d36e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports